import { useState } from 'react';

import { TextField } from '@components/text-field';

import { useUpdateCompanyInfo } from 'api/companies/hooks';
import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';
import { Company } from 'types/companies';

import { SettingsModal } from './settings-modal';

type EditMessagesSenderNameModalProps = ModalProps<{
  currentSenderName: Company['senderName'];
}>;

export const EditMessagesSenderNameModal = ({
  currentSenderName,
}: EditMessagesSenderNameModalProps) => {
  const { t } = useStore();
  const [senderName, setSenderName] = useState(currentSenderName ?? '');
  const submit = useUpdateCompanyInfo({
    successMessage: t('company.settings.root.messagessendername.updateSuccess'),
    errorMessage: t('company.settings.root.messagessendername.updateError'),
  });

  const isValid = Boolean(senderName.length);

  return (
    <SettingsModal
      title={t('company.settings.root.messagessendername.title')}
      description={t('company.settings.root.messagessendername.description')}
      onSave={() => submit.mutate({ senderName })}
      saveDisabled={!isValid || submit.isLoading}
    >
      <TextField
        label={t('company.settings.root.messagessendername.label')}
        placeholder={t('company.settings.root.messagessendername.placeholder')}
        value={senderName}
        error={
          !isValid && senderName !== currentSenderName
            ? t('company.settings.root.messagessendername.error')
            : undefined
        }
        onChange={setSenderName}
      />
    </SettingsModal>
  );
};
